const iconNames = {
    project: 'water_damage',
    construction_project: 'location_city',
    building: 'apartment',
    company: 'format_paint',
    contact: 'person',
    contract: 'description',
    email: 'mail',
    mailing: 'mail_outline',
    phone: 'phone',
    mailing_out: 'send',
    mailing_in: 'save_alt',

};

export default iconNames;
